import styled from '@emotion/styled';

// import { FullTextLogo } from '../../../components/CompanyLogo';
import { CompanyLetterLogo } from '../../../components/CompanyLogo/CompanyLogo';
import { HoverDropDown } from '../../../components/DropDown/DropDown';
import { DownChevron } from '../../../components/Icons/DownChevron';
import NotificationIcon from '../../../components/Icons/NotificationIcon';
import SignOutIcon from '../../../components/Icons/SignOutIcon';
import { StyledRouterLink } from '../../../components/Link/Link';
import useAuth from '../../../hooks/useAuth';
import { useAppSelector } from '../../../redux/store';
import { truncateString } from '../../../utils/utils';
import { HeaderNav } from '../nav/HeaderNav';

export const Header: React.FC<IHeader> = ({ navState }) => {
  const { logoutUser } = useAuth();
  const { authData } = useAppSelector((state) => state.auth);

  const handleLogout = () => {
    logoutUser();
  };

  return (
    <StyledHeader>
      <IconSection>
        <CompanyLogoWrapper>
          <CompanyLetterLogo />
        </CompanyLogoWrapper>
        <HeaderNav />
        <IconsStack>
          <StyledRouterLink to="/notifications">
            <NotificationIcon />
          </StyledRouterLink>
          <ProfileInfoArea>
            <HoverDropDown
              label={
                <DropDownLabel>
                  {truncateString(authData?.user.firstName, 18) || 'unknown'}
                  <DownChevron />
                </DropDownLabel>
              }
            >
              <DropDownContent onClick={handleLogout}>
                <SignOutIcon />
                Logout
              </DropDownContent>
            </HoverDropDown>
          </ProfileInfoArea>
        </IconsStack>
      </IconSection>
    </StyledHeader>
  );
};

const CompanyLogoWrapper = styled.div`
  @media screen and (max-width: 480px) {
    display: none;
  }
`;

const IconsStack = styled.div`
  display: flex;
  align-items: center;
  gap: 2em;
`;

const ProfileInfoArea = styled.div`
  display: flex;
  /* border: 2px solid red; */
  align-items: center;
  gap: 0.5rem;
  color: black;
`;

const DropDownLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const DropDownContent = styled.div`
  display: grid;
  grid-template-columns: 22px auto;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem 1rem;
  width: fit-content;
  color: #867c79;
`;
const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  /* border: 2px solid red; */
  z-index: 10;
  position: sticky;
  top: 0;
  /* background-color: ${({ theme }) => theme.palette.primaryBgColor}; */
  background-color: white;
  & > * {
    padding: 0 2.5rem;
    height: 5rem;
    /* border-bottom: 1px solid ${({ theme }) =>
      theme.palette.primaryBorderColor}; */
  }

  @media screen and (max-width: 540px) {
    & > * {
      padding: 0 1rem 0 3rem;
    }
  }
`;

const IconSection = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

interface IHeader {
  navState: boolean;
}
